module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--1-05316dc02f9a74c8e4dd1f7266af8431.png";